/**
 * @generated SignedSource<<3a782142a02e1c1b2b6776229827a96f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type opinionArticleContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"contentSchemaRenderContent" | "headerOpinionArticle" | "hooksContentHelperContent">;
  readonly " $fragmentType": "opinionArticleContent";
};
export type opinionArticleContent$key = {
  readonly " $data"?: opinionArticleContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"opinionArticleContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "opinionArticleContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "headerOpinionArticle"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "hooksContentHelperContent"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "contentSchemaRenderContent"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "9823dd1988e7f12545e4d50a85184c66";

export default node;
